import angular from 'angular';
import _ from 'lodash';

class MenuElements {

  constructor($state, LoadedModel) {
      this._$state = $state;
      this._LoadedModel = LoadedModel;
      this.initMenu();
      this.resetStates();
  }

  resetStates() {
      this.activeStates = this._LoadedModel.passedSteps.slice(0);
  }

  get() {
      return this._menuElements;
  }

  initMenu() {
      this._menuElements = [{
          state: 'home',
          letter: 'O',
          name: 'Part',
          isValid: () => {
            return !this._LoadedModel.isThicknessValid();
          }
      }, {
          state: 'feasibility',
          activeState: 'part',
          letter: 'T',
          name: 'Feasibility',
          isValid: () => {
            return true;
          }
      }, {
          state: 'blank',
          activeState: 'feasibility',
          letter: 'B',
          name: 'Blank',
          isValid: () => {
            return true;
          }
      }, {
          state: 'nest',
          activeState: 'blank',
          letter: 'L',
          name: 'Nest',
          isValid: () => {
            return true;
          }
      }, {
          state: 'report',
          activeState: 'nest',
          letter: 'R',
          name: 'Report',
          isValid: () => {
            return true;
          }
      }];
  }

  updateActiveStates(step, soft) {
      if (step && (!soft || soft && this.activeStates.indexOf(step) === -1)) {
          this.activeStates = this._LoadedModel.addPassedStep(step);
      }
  }

  isStateEnabled(stateName) {
      if (!stateName) {
          return false;
      }
      let element = _.find(this._menuElements, {state: stateName});
      return !element.activeState || this.activeStates.indexOf(element.activeState) !== -1;
  }
}

MenuElements.$inject = ['$state', 'LoadedModel'];

let MenuElementsService = angular.module('app.common.services')
  .service('MenuElements', MenuElements)
  .name;


export default MenuElementsService



// WEBPACK FOOTER //
// ./client/app/common/services/menu-elements.js